import type { HelpFile } from '../../types/help'
import { AccessAnalyticsDashboardTestIds } from '../../../testids/AccessAnalyticsDashboardTestIds'

export const accessAnalyticsDashboardHelp: HelpFile = {
  docPage: '/docs/analytics/access-analytics',
  texts: {
    [AccessAnalyticsDashboardTestIds.accessAnalyticsDashboardPage]:
      'Überblick über die effektiven Zugriffsrechte in der Organisation — zeigt die Identitäten und Zielsysteme mit den meisten gewährten Zugriffen.',
    [AccessAnalyticsDashboardTestIds.cardTitleTopIdentities]:
      'Identitäten, sortiert nach der Anzahl der aktuell gehaltenen effektiven Zugriffsrechte.',
    [AccessAnalyticsDashboardTestIds.cardTitleTopSystems]:
      'Zielsysteme, sortiert nach der Anzahl der derzeit darauf gewährten effektiven Zugriffsrechte.',
    [AccessAnalyticsDashboardTestIds.colGrants]:
      'Anzahl der effektiven Zugriffsrechte — summiert alle Berechtigungen aus direkten Zuweisungen, Rollenmitgliedschaften und regelbasiertem Zugriff.',
    [AccessAnalyticsDashboardTestIds.colIdentity]:
      'Identität, der die effektiven Berechtigungen zugeordnet sind.',
    [AccessAnalyticsDashboardTestIds.colSystem]:
      'Zielsystem, auf dem die Berechtigungen vergeben sind.',
    [AccessAnalyticsDashboardTestIds.filterPeriod]:
      'Beschränkt die Auswertung auf Rechte, die innerhalb eines gewählten Zeitraums wirksam sind.',
    [AccessAnalyticsDashboardTestIds.inputAnalyticsFrom]:
      'Beginn des benutzerdefinierten Zeitraums — nur ab diesem Zeitpunkt wirksame Rechte werden berücksichtigt.',
    [AccessAnalyticsDashboardTestIds.inputAnalyticsTo]:
      'Ende des benutzerdefinierten Zeitraums — nur bis zu diesem Zeitpunkt wirksame Rechte werden berücksichtigt.',
    [AccessAnalyticsDashboardTestIds.linkIdentitiesWithGrants]:
      'Öffnet die vollständige Liste der Identitäten mit ihren effektiven Zugriffsrechten.',
    [AccessAnalyticsDashboardTestIds.linkTargetSystems]:
      'Öffnet die Zielsystem-Liste, um in die Rechte eines Systems hineinzuzoomen.',
  },
}
